/**
 * 전역 Portal 레이어 순서.
 * 모달 내부의 깊이는 ModalHost 안에서만 관리하며, 이 값들과 직접 경쟁하지 않는다.
 */
export const Z_INDEX = {
  baseFloating: 50,
  modalHost: 1000,
  toast: 1100,
  loading: 1200,
  drag: 1300,
} as const;
